import { Controller } from "remult";

@Controller("user-skill-methods")
export class UserSkillMethods {}
